module.exports = __webpack_public_path__ + "img/home-photo.07ab7ef3.jpg";